import { Component, Input, OnInit } from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { id } from '@swimlane/ngx-charts';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { Md5 } from 'ts-md5/dist/md5';

@Component({
  selector: 'app-listado-tarjetas',
  templateUrl: './listado-tarjetas.component.html',
  styleUrls: ['./listado-tarjetas.component.scss'],
})
export class ListadoTarjetasComponent implements OnInit {
  cargado = false;
  @Input() MensajeRecibos: boolean = false;
  @Input() UserID = '';
  @Input() Titulo = 'Seleccione su método de pago';
  Tarjetas = [];
  constructor(
    public utilidades: UtilidadesService,
    private nav: NavController,
    private conexion: ConexionService,
    private modal: ModalController,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.getTarjetas();
    }, 5);
  }

  NavAgregarTarjeta() {
    if (this.MensajeRecibos) {
      this.nav.navigateForward(
        '/registro-tarjeta/' + btoa('DespuesDeAgregarEstaTarjetaIrACheckout')
      );
      this.modal.dismiss();
    } else {
      this.nav.navigateForward('/registro-tarjeta');
    }
  }

  SeleccionarTarjeta(tarjeta) {
    if (!this.MensajeRecibos || this.ColorVencida(tarjeta)) return 0;
    localStorage.setItem(btoa('CarritoTarjeta'), btoa(JSON.stringify(tarjeta)));
    this.nav.navigateForward('/checkout');
    this.modal.dismiss();
  }

  EliminarTarjeta(tarjeta, indice) {
    if(!confirm("¿Desea eliminar de forma permanente la tarjeta?")) return 0;
    
    this.utilidades.Loading('Eliminando tarjeta');
    this.conexion.EliminarTarjeta(tarjeta).subscribe(
      (resp) => {
        this.utilidades.CerrarLoading();
        this.utilidades.Alerta(resp.Mensaje);
        if (resp.Respuesta == 'Exito') {
          this.Tarjetas.splice(indice, 1);
        }
      },
      (err) => {
        this.utilidades.Depuracion(err.error.Mensaje, '', err.error.Codigo);
        this.utilidades.CerrarLoading();
        this.utilidades.ValidarUser(err);
      }
    );
  }

  async EscribirPasswordConfirmarEliminarTarjeta(tarjeta, indice) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Escribe tu contraseña',
      message: 'Para eliminar esta tarjeta por favor confirma tu contraseña',
      inputs: [
        {
          name: 'password',
          type: 'password',
          placeholder: 'Contraseña',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {},
        },
        {
          text: 'Confirmar contraseña',
          handler: (dato) => {
            this.utilidades.Loading('Confirmando');
            this.conexion
              .Login(
                atob(localStorage.getItem(btoa('Email'))),
                this.HashPass(dato.password)
              )
              .subscribe(
                (resp) => {
                  if (resp.Respuesta == 'Exito') {
                    this.EliminarTarjeta(tarjeta, indice);
                  } else {
                    this.utilidades.Alerta('Contraseña incorrecta');
                  }
                  setTimeout(() => {
                    this.utilidades.CerrarLoading();
                  }, 300);
                },
                (err) => {
                  this.utilidades.Alerta('Contraseña incorrecta');
                  setTimeout(() => {
                    this.utilidades.CerrarLoading();
                  }, 300);
                }
              );
          },
        },
      ],
    });

    await alert.present();
  }

  HashPass(password: string): string {
    const md5 = new Md5();
    return String(md5.appendStr(password).end());
  }

  getTarjetas() {
    this.conexion.getTarjetas(this.UserID).subscribe(
      (resp) => {
        if (resp.Respuesta == 'Exito') {
          this.Tarjetas = resp.Datos;
        }
        this.cargado = true;
      },
      (err) => {
        this.utilidades.Depuracion(err.error.Mensaje, '', err.error.Codigo);

        this.cargado = true;
        this.utilidades.ValidarUser(err);
      }
    );
  }

  ColorVencida(card){
    let fecha = new Date();
    let month = fecha.getMonth() + 1
    let year = fecha.getFullYear()
    if(year > Number(card.CardYear) || (year==Number(card.CardYear) && month > Number(card.CardMonth))){
      return "#ffe6ea"
    }

    return ""
  }

  getFotoTarjeta(cardType) {
    switch (cardType) {
      case '001':
        return './assets/imagenes/Visa_logo.png';
        break;

      case '002':
        return './assets/imagenes/logo-Mastercard.png';
        break;

      case '003':
        return './assets/imagenes/logo-american-express.png';
        break;

      default:
        return './assets/imagenes/tarjeta-no-reconocida.jpg';
    }
  }
  CerrarLista() {
    this.modal.dismiss();
  }
}
